import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('SendPasswordApp => ');

const onSendPasswordRequest = createAction('send password request');
const onSendPasswordSuccess = createAction('send password success');
const onSendPasswordFailure = createAction('send password failure');

export default {
  onSendPasswordRequest,
  onSendPasswordSuccess,
  onSendPasswordFailure,
};
